import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { type PointsGroup } from 'src/features/parkingManagement/types/pointsGroup';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/points-group/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    name: z.string().min(1, { message: validationMessagesMap.validationErrorRequired }),
    points: z.array(z.string()).nonempty(),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<PointsGroup> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePointsGroup, formSchema as CreatePointsGroupFormSchema };
export type { FormSchemaValues as CreatePointsGroupFormSchemaValues };
